import React, { useEffect, useRef, useState, useMemo } from "react";
import { Circles } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FamilyTree from "../../../lib/@balkangraph/familytree.js";
import AddMemberFromTreeModal from "../../../modals/yourAssets/FT/AddMemberFromTreeModal";
import EditMemberModal from "../../../modals/yourAssets/FT/EditMemberModal";

import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import {
  getFamilyTree,
  updateAuditTrials,
} from "../../../services/yourAssets/FamilyTreeServices";
import { setFamilyMembersList } from "../../../utils/FTUtilities";
import { relationships } from "../../../constants/constants";
import { BASE_URL, FT_KEY, VERSION } from "../../../constants/ApiUrls";
import { Toaster } from "react-hot-toast";
import ModifiedByToaster from "../../../common/ModifiedByToaster/index.js";
import {
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  changeUpdateFormat,
} from "../../../utils/Utilities.js";

const FamilyChart = (props) => {
  const { t, i18n } = useTranslation();
  const state = useSelector((state) => state.currentLanguage);
  const [loading, setLoading] = useState(false);
  const { listTrials: trialsList } = props;
  const { id } = useParams();
  const [complicatedRelation, setComplicatedRelation] = useState(false);

  const [addMemberModal, setAddMemberModal] = useState(false);
  const [editMemberModal, setEditMemberModal] = useState(false);
  const [currentNode, setCurrentNode] = useState({});
  const [auditTrialList, setAuditTrialList] = useState([]);
  const [refreshTree, setRefreshTree] = useState(false);
  const [defaultValue, setDefaultValue] = useState("");
  const divRef = useRef();
  const memoizedTrial = useMemo(() => trialsList, [trialsList]);
  const getTree = async () => {
    setLoading(true);
    try {
      let result = await getFamilyTree(id);
      if (result?.familyTree?.length) {
        let changedObjects = [];

        for (let i = 0; i < trialsList?.length; i++) {
          const elementI = trialsList[i];
          changedObjects.push(elementI.auditTrailId);

          for (let j = 0; j < result?.familyTree?.length; j++) {
            const elementJ = result?.familyTree[j];
            if (
              elementI.objectName === "UserFamilyTree" &&
              elementI.keyValues.ObjectId === elementJ.familyTreeId
            ) {
              elementJ.shadow = "/assets/icons/shadow.png";
              setAuditTrialList([...auditTrialList, elementI]);
            }
          }
        }
        if (changedObjects.length) {
          await updateAuditTrials(id, changedObjects);
        }
        for (let i = 0; i < result?.familyTree?.length; i++) {
          const element = result?.familyTree[i];
          if (element.gender === "other") {
            element.gender = "female";
          }

          if (
            element.relationship !== "Pet" &&
            element.relationship !== "Friend"
          ) {
            element.addNew = "/assets/icons/plus.png";
          }

          if (element.complicatedRelation && !element.isDead) {
            element.isAliveImage = "/assets/icons/bolt.png";
          } else if (element.isDead && !element.complicatedRelation) {
            element.isAliveImage = "/assets/icons/cross.png";
          } else if (element.complicatedRelation && element.isDead) {
            element.isAliveImage = "/assets/icons/cross.png";
          }
          if (
            element.firstName &&
            element.lastName &&
            element.dateOfBirth &&
            element.relationship !== "Pet"
          ) {
            element.edit = "/assets/icons/tick.png";
          } else if (
            element.firstName &&
            element.dateOfBirth &&
            element.relationship === "Pet"
          ) {
            element.edit = "/assets/icons/tick.png";
          } else {
            element.edit = "/assets/icons/edit.png";
          }

          if (!element.pictureId) {
            switch (element.relationship) {
              case "root":
                if (element.gender === "male") {
                  element.profilePicture = "/assets/icons/you.png";
                } else {
                  element.profilePicture = "/assets/icons/partner-female.png";
                }
                break;
              case "Partner-Male":
                element.profilePicture = "/assets/icons/partner-male.png";
                break;
              case "Partner-Female":
                element.profilePicture = "/assets/icons/partner-female.png";
                break;
              case "Ex-Partner-Male":
                element.profilePicture = "/assets/icons/ex-partner-male.png";
                break;
              case "Ex-Partner-Female":
                element.profilePicture = "/assets/icons/ex-partner-female.png";
                break;
              case "Father":
                element.profilePicture = "/assets/icons/parent-male.png";
                break;
              case "Mother":
                element.profilePicture = "/assets/icons/parent-female.png";
                break;
              case "Brother":
                element.profilePicture = "/assets/icons/sibling-male.png";
                break;
              case "Sister":
                element.profilePicture = "/assets/icons/sibling-female.png";
                break;
              case "Son":
                element.profilePicture = "/assets/icons/child-male.png";
                break;
              case "Daughter":
                element.profilePicture = "/assets/icons/child-female.png";
                break;

              default:
                break;
            }
          } else {
            //element.profilePicture = S3_URL + element.picturePath;
            element.profilePicture =
              BASE_URL +
              FT_KEY +
              VERSION +
              id +
              "/familytree-image?familyTreeImageId=" +
              element.pictureId;
          }
        }

        setFamilyMembersList(result?.familyTree);
        result = result?.familyTree?.filter(
          (item) =>
            item.relationship !== "Pet" && item.relationship !== "Friend"
        );
        let arr = [];
        result.forEach((member) => {
          arr = [
            ...arr,
            { ...member, relationship: t(getKeyFromText(member.relationship)) },
          ];
        });
        const family = new FamilyTree(divRef.current, {
          nodeMouseClick: FamilyTree.action.none,
          template: "myTemplate",
          enableSearch: false,
          nodeBinding: {
            field_0: "firstName",
            field_1: "lastName",
            field_2: "relationship",
            img_3: "shadow",
            photo: "profilePicture",
            img_1: "edit",
            img_4: "addNew",
            img_2: "isAliveImage",
          },

          nodes: arr,
          showXScroll: true,
          showYScroll: true,
          sticky: false,
        });

        family.onNodeClick((data) => {
          let clickedButton = data.event.srcElement.id;
          let node = data.node;
          let nodeElement = family.getNodeElement(node.id);
          let nodeData = family.get(node.id);
          setCurrentNode(JSON.parse(JSON.stringify(nodeData)));
          let editIndex;
          let addIndex;
          let lastIndex = nodeElement.childNodes.length - 1;
          if (nodeData.gender === "male") {
            if (lastIndex === 7) {
              editIndex = 6;
              addIndex = 7;
            } else if ([8, 9].includes(lastIndex)) {
              editIndex = 7;
              addIndex = 8;
            } else if ([10, 11, 12].includes(lastIndex)) {
              editIndex = 10;
              addIndex = 11;
            } else if ([6].includes(lastIndex)) {
              editIndex = 5;
              addIndex = 6;
            }
          } else {
            if (lastIndex === 6) {
              editIndex = 5;
              addIndex = 6;
            } else if ([7, 8].includes(lastIndex)) {
              editIndex = 6;
              addIndex = 7;
            } else if ([9, 10, 11].includes(lastIndex)) {
              editIndex = 9;
              addIndex = 10;
            } else if ([5].includes(lastIndex)) {
              editIndex = 4;
              addIndex = 5;
            } else if ([6].includes(lastIndex)) {
              editIndex = 5;
              addIndex = 6;
            }
          }

          nodeElement.childNodes[editIndex].addEventListener("click", () =>
            handleClick(nodeData, "edit")
          );
          nodeElement.childNodes[addIndex].addEventListener("click", () =>
            handleClick(nodeData, "add")
          );
          if (clickedButton == "add") {
            nodeElement.childNodes[addIndex].dispatchEvent(new Event("click"));
          } else if (clickedButton == "edit") {
            nodeElement.childNodes[editIndex].dispatchEvent(new Event("click"));
          }
        });
        family.on("render-link", (sender, args) => {
          args.html = args.html.replace("path", "path stroke-dasharray='4, 4'");
        });

        FamilyTree.templates.myTemplate = Object.assign(
          {},
          FamilyTree.templates.tommy
        );
        FamilyTree.templates.myTemplate.size = [200, 200];

        FamilyTree.templates.myTemplate.defs = ``;

        FamilyTree.templates.myTemplate.photo =
          `<defs>
    <rect id="rect1"  x="60" y="30" width="80" height="80" rx="50%"/>
      <clipPath id="clip1">
        <use xlink:href="#rect1"/>
      </clipPath>
      </defs><image  preserveAspectRatio="xMidYMid slice" clip-path="url(#clip1)" xlink:href="{val}"  x="60" y="30" width="80" height="80">` +
          "</image>";

        FamilyTree.templates.myTemplate.img_1 =
          `<image id="edit"  preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="90" width="20" height="20">` +
          "</image>";
        FamilyTree.templates.myTemplate.img_2 =
          '<image preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="60" y="28" width="20" height="20">' +
          "</image>";

        FamilyTree.templates.myTemplate.img_4 =
          '<image id="add" preserveAspectRatio="xMidYMid slice" clip-path="url(#ulaImg)" xlink:href="{val}" x="120" y="28" width="20" height="20">' +
          "</image>";

        FamilyTree.templates.myTemplate.img_3 =
          `<defs>
    <rect id="rect"  x="10" y="2" width="250" height="250" rx="1%"/>
      <clipPath id="clip">
        <use xlink:href="#rect"/>
      </clipPath>
      </defs>
      <image id="1222" preserveAspectRatio="xMidYMid slice" clip-path="url(#clip)" xlink:href="{val}"  x="-25" y="-45" width="250" height="250" >` +
          "</image>";

        FamilyTree.templates.myTemplate.field_0 =
          '<text style="font-size: 12px;" fill="#000" x="100" y="130" text-anchor="middle">{val}</text>';

        FamilyTree.templates.myTemplate.field_1 =
          '<text style="font-size: 10px;" fill="#000" x="100" y="150" text-anchor="middle">{val}</text>';
        FamilyTree.templates.myTemplate.field_2 =
          '<text style="font-size: 10px;" fill="#000" x="100" y="20" text-anchor="middle">{val}</text>';

        FamilyTree.templates.myTemplate_male = Object.assign(
          {},
          FamilyTree.templates.myTemplate
        );

        FamilyTree.templates.myTemplate_female = Object.assign(
          {},
          FamilyTree.templates.myTemplate
        );

        FamilyTree.templates.myTemplate_male.node = `<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle> `;

        FamilyTree.templates.myTemplate_female.node =
          '<circle cx="100" cy="100" r="0" fill="transparent" stroke-width="1" stroke="transparent"></circle>';

        FamilyTree.templates.myTemplate.link =
          '<path stroke="#123123" stroke-width="1px" fill="#182931" data-l-id="[{id}][{child-id}]" d="M{xa},{ya} C{xb},{yb} {xc},{yc} {xd},{yd}" />';

        setRefreshTree(false);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTree();
  }, [memoizedTrial, state]);
  useEffect(() => {
    if (refreshTree) getTree();
  }, [refreshTree]);

  const handleClick = (item, key) => {
    if (key === "edit") {
      setEditMemberModal(true);
      for (let i = 0; i < relationships.length; i++) {
        const element = relationships[i];
        if (element.name === item.relationship) {
          setDefaultValue(element);
        }
      }
    } else if (key === "add") {
      setAddMemberModal(true);
    }
  };

  const refreshFamilyTree = () => {
    setRefreshTree(true);
  };

  return (
    <>
      <Toaster />
      <Box
        component="div"
        className="family-chart"
        sx={{ position: "relative", height: "100%" }}
      >
        <div
          id="tree"
          ref={divRef}
          style={{ visibility: loading ? "hidden" : "visible" }}
        ></div>

        {loading && (
          <div className="loader">
            <Circles color="#dfc8db" height={80} width={80} />
          </div>
        )}
      </Box>

      <AddMemberFromTreeModal
        open={addMemberModal}
        handleClose={() => {
          setAddMemberModal(false);
          setComplicatedRelation(false);
        }}
        handleComplicatedRelation={() => {
          setComplicatedRelation(!complicatedRelation);
        }}
        complicatedRelation={complicatedRelation}
        currentNode={currentNode}
        defaultValue={defaultValue}
        refresh={refreshFamilyTree}
        userId={id}
      />
      <EditMemberModal
        open={editMemberModal}
        handleClose={() => {
          setEditMemberModal(false);
        }}
        defaultValue={defaultValue}
        currentNode={currentNode}
        refresh={refreshFamilyTree}
        enableSelection={true}
        userId={id}
      />

      {auditTrialList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${auditTrialList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            auditTrialList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
    </>
  );
};

export default FamilyChart;
